import MainLayoutDetail from "../components/layout/MainLayoutDetail";
import MainLayoutUser from "../components/layout/MainLayoutUser";
import MainLayoutAdmin from "../components/layout/MainLayoutAdmin";
import JobDetailLayout from "../components/organisms/JobDetailLayout";
import BannerJobSearch from "../components/organisms/BannerJobSearch";
import { useEffect } from "react";
import { useAuthStore } from "../store/useAuthStore";

export default function JobsDetail() {
    const { accessToken, type } = useAuthStore();
  useEffect(() => {
    document.title = "TalentLink | Jobs";

    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "Halaman utama TalentLink");
    }
  }, []);

    const Layout =
      !accessToken
        ? MainLayoutDetail
        : type === "candidate"
          ? MainLayoutUser
          : type === "company"
            ? MainLayoutAdmin
            : MainLayoutDetail;

  return (
    <Layout>
      <JobDetailLayout />
    </Layout>
  );
}
